import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'
import numeral from 'numeral'

// Components
import { CurrencyInput, Input } from '../../..'

// Helpers
import { calculatePercent, percentToDecimal } from '../../../../helpers/math'

import styles from './AmountPercentInput.module.scss'

const AmountPercentInput = ({
  total,
  amount,
  name,
  placeholder: amountPlaceholder,
  onChange,
  autoFocus,
  ...restProps
}) => {
  const amountInputName = name || 'amount'
  const percentInputName = name ? `${name}Percent` : 'percent'
  const [percent, setPercent] = useState('')

  useEffect(() => {
    if (amount && total) {
      setPercent(calculatePercent(amount, total))
    }
  }, [])

  const handleChange = e => {
    const {
      target: { name, value },
    } = e

    let newAmount

    switch (name) {
      case percentInputName:
        newAmount = total * percentToDecimal(value)
        setPercent(value)
        break
      case amountInputName:
        newAmount = value
        setPercent(calculatePercent(value, total))
        break
      default:
        console.log('Unexpected name')
    }

    if (onChange) {
      onChange({
        target: { name: amountInputName, value: newAmount },
      })
    }
  }

  return (
    <div className={styles.amountPercentInput}>
      <CurrencyInput
        {...restProps}
        name={amountInputName}
        placeholder={amountPlaceholder}
        className={styles.amountField}
        value={amount || ''}
        allowNegative={false}
        onChange={handleChange}
        autoFocus={autoFocus}
        isNumericString
      />
      <NumberFormat
        {...restProps}
        name={percentInputName}
        placeholder={
          amountPlaceholder &&
          `${calculatePercent(
            numeral(amountPlaceholder).value(),
            total
          ).toFixed(0)}%`
        }
        className={styles.percentField}
        value={percent || ''}
        customInput={Input}
        suffix='%'
        decimalScale={0}
        isAllowed={({ value }) => value <= 100}
        allowNegative={false}
        isNumericString
        onChange={e => {
          const {
            target: { value, name },
          } = e

          handleChange({
            target: {
              name,
              value: value.replace(/%/g, ''),
            },
          })
        }}
      />
    </div>
  )
}

AmountPercentInput.propTypes = {
  total: PropTypes.number,
  amount: PropTypes.number,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  autoFocus: PropTypes.bool,
}

export default AmountPercentInput
